// extracted by mini-css-extract-plugin
export var brand = "_an-9";
export var compact = "_an-6";
export var extraSmall = "_an-7";
export var icon = "_an-0";
export var large = "_an-4";
export var light = "_an-1";
export var medium = "_an-5";
export var outline = "_an-b";
export var primaryDark = "_an-a";
export var primaryLight = "_an-8";
export var primaryModern = "_an-c";
export var success = "_an-2";
export var successSolid = "_an-3";